import variables from '@/assets/styles/element-variables.scss';
import defaultSettings from '@/settings';
var tagsView = defaultSettings.tagsView,
  fixedHeader = defaultSettings.fixedHeader,
  sidebarLogo = defaultSettings.sidebarLogo,
  uniqueOpened = defaultSettings.uniqueOpened,
  showFooter = defaultSettings.showFooter,
  footerTxt = defaultSettings.footerTxt,
  caseNumber = defaultSettings.caseNumber;
var state = {
  theme: variables.theme,
  showSettings: false,
  showModel: false,
  tagsView: tagsView,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  uniqueOpened: uniqueOpened,
  showFooter: showFooter,
  footerTxt: footerTxt,
  caseNumber: caseNumber
};
var mutations = {
  CHANGE_SETTING: function CHANGE_SETTING(state, _ref) {
    var key = _ref.key,
      value = _ref.value;
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  },
  CHANGE_MODEL: function CHANGE_MODEL(state, _ref2) {
    var key = _ref2.key,
      value = _ref2.value;
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  }
};
var actions = {
  changeSetting: function changeSetting(_ref3, data) {
    var commit = _ref3.commit;
    commit('CHANGE_SETTING', data);
  },
  changeModel: function changeModel(_ref4, data) {
    var commit = _ref4.commit;
    commit('CHANGE_MODEL', data);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};